module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface and Guidance Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ionian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C Ionian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F Ionian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dorian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bb Dorian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phrygian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C# Phrygian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lydian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C Lydian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mixolydian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G Mixolydian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aeolian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B Aeolian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 4")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locrian Licks")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D Locrian Scales")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-3"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lick 3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank you for buying this Book")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0001#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("eBooks & Books Also Available")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 57
// module chunks = 0